export default "__VITE_ASSET__DOuTw2Y0__"